/* eslint-disable prettier/prettier */
import {
	Button,
	Badge,
	CellGroup,
	Cell,
	Icon,
	Image,
	Popup,
	Toast,
	Calendar,
	Checkbox,
	CheckboxGroup,
	DatetimePicker,
	Field,
	Form,
	NumberKeyboard,
	PasswordInput,
	Picker,
	RadioGroup,
	Radio,
	Switch,
	Uploader,
	ActionSheet,
	Dialog,
	DropdownMenu,
	DropdownItem,
	Loading,
	Notify,
	Overlay,
	PullRefresh,
	SwipeCell,
	Collapse,
	CollapseItem,
	CountDown,
	Divider,
	Empty,
	ImagePreview,
	Lazyload,
	List,
	NoticeBar,
	Popover,
	Sticky,
	Swipe,
	SwipeItem,
	Tag,
	Grid,
	GridItem,
	NavBar,
	Pagination,
	Sidebar,
	SidebarItem,
	Tab,
	Tabs,
	TreeSelect,
	Tabbar,
	TabbarItem,
	Progress,
	Step,
	Steps,
	Search,
	Row,
	Col
} from 'vant'
import 'vant/lib/index.less'

const VantComponets = [
	Button,
	Badge,
	CellGroup,
	Cell,
	Icon,
	Image,
	Popup,
	Toast,
	Calendar,
	Checkbox,
	CheckboxGroup,
	DatetimePicker,
	Field,
	Form,
	NumberKeyboard,
	PasswordInput,
	Picker,
	RadioGroup,
	Radio,
	Switch,
	Uploader,
	ActionSheet,
	Dialog,
	DropdownMenu,
	DropdownItem,
	Loading,
	Notify,
	Overlay,
	PullRefresh,
	SwipeCell,
	Collapse,
	CollapseItem,
	CountDown,
	Divider,
	Empty,
	ImagePreview,
	Lazyload,
	List,
	NoticeBar,
	Popover,
	Sticky,
	Swipe,
	SwipeItem,
	Tag,
	Grid,
	GridItem,
	NavBar,
	Pagination,
	Sidebar,
	SidebarItem,
	Tab,
	Tabs,
	TreeSelect,
	Tabbar,
	TabbarItem,
	Progress,
	Step,
	Steps,
	Search,
	Col,
	Row
]

export default {
	install: function (Vue) {
		// Toast.setDefaultOptions({ duration: 5000 });
		VantComponets.forEach((item) => Vue.use(item))
	}
}
